export default {
  'easyRecord.page.dashboard': '记录易工作台',
  'easyRecord.page.threads': '主题管理',
  'easyRecord.page.records': '记录管理',
  'easyRecord.page.search': '搜索与回溯',
  'easyRecord.page.settings': '设置',
  'easyRecord.page.tags': '标签管理',

  'easyRecord.dashboard.kicker': '内容总览',
  'easyRecord.dashboard.description': '聚焦最近主题、今日记录与近期活跃内容',
  'easyRecord.dashboard.workspaceTitle': '记录工作台',
  'easyRecord.dashboard.workspaceDescription':
    '汇总今天的收集、近期沉淀和主题整理进展，帮助你判断下一步该继续记录、归类还是回看。',
  'easyRecord.dashboard.summary.today': '今日收集',
  'easyRecord.dashboard.summary.todayDesc': '当天新增记录',
  'easyRecord.dashboard.summary.week': '近 7 日沉淀',
  'easyRecord.dashboard.summary.weekDesc': '日均 {count} 条',
  'easyRecord.dashboard.summary.activeThreads': '活跃主题',
  'easyRecord.dashboard.summary.activeThreadsDesc': '近期有内容的主题',
  'easyRecord.dashboard.focusThreads': '继续整理的主题',
  'easyRecord.dashboard.contentStructure': '内容结构',
  'easyRecord.dashboard.latestCaptures': '最新收集',
  'easyRecord.dashboard.scopeLabel': '当前范围',
  'easyRecord.dashboard.scopeAll': '全部权限范围内记录',
  'easyRecord.dashboard.scopeSource': '当前业务来源记录',
  'easyRecord.dashboard.organizeQueue': '待整理队列',
  'easyRecord.dashboard.queue.inbox': '未归入主题',
  'easyRecord.dashboard.queue.untagged': '未打标签',
  'easyRecord.dashboard.queue.important': '重要记录',
  'easyRecord.dashboard.queue.activeThreads': '活跃主题',
  'easyRecord.dashboard.queue.inboxHint': '归入合适主题，建立内容上下文',
  'easyRecord.dashboard.queue.untaggedHint': '补充标签，提升搜索和回溯效率',
  'easyRecord.dashboard.queue.importantHint': '回看重点内容并确认后续动作',
  'easyRecord.dashboard.organizeQueueDesc':
    '优先处理没有主题、没有标签或需要回看的内容。',
  'easyRecord.dashboard.latestCapturesDesc':
    '最近进入记录易的内容，便于快速补充上下文。',
  'easyRecord.dashboard.focusThreadsDesc': '近期仍在沉淀的主题。',
  'easyRecord.dashboard.contentStructureDesc': '查看当前内容资产的类型构成。',
  'easyRecord.dashboard.assetHealth': '整理覆盖率',
  'easyRecord.dashboard.noTags': '暂无标签',
  'easyRecord.dashboard.noPreview': '暂无可展示内容',
  'easyRecord.dashboard.pulse.today': '今日收集',
  'easyRecord.dashboard.pulse.week': '近 7 日沉淀',
  'easyRecord.dashboard.pulse.average': '日均记录',
  'easyRecord.dashboard.todayTitle': '今天的记录工作台',
  'easyRecord.dashboard.todaySummary':
    '今日新增 {today} 条记录，近 7 日累计 {week} 条。先处理新内容，再回看重点主题。',
  'easyRecord.dashboard.focusHeadline':
    '今日新增 {today} 条记录，待整理 {queue} 项',
  'easyRecord.dashboard.focusPendingDescription':
    '先完成新内容的归类和打标，再继续推进近期主题。',
  'easyRecord.dashboard.focusClearDescription':
    '待整理队列已经清空，可以继续记录新的内容。',
  'easyRecord.dashboard.action.organize': '开始整理',
  'easyRecord.dashboard.action.manageTopics': '管理主题',
  'easyRecord.dashboard.todayCapture': '今日收集',
  'easyRecord.dashboard.weekTotal': '近 7 日 {count} 条',
  'easyRecord.dashboard.recentActivity': '近期活跃',
  'easyRecord.dashboard.latestActivityAt': '最近更新 {time}',
  'easyRecord.dashboard.noActivity': '暂无更新',
  'easyRecord.dashboard.insightTitle': '记录类型分布',
  'easyRecord.dashboard.insightDescription':
    '从近期沉淀的内容里，快速看到当前记录重心落在哪些类型。',
  'easyRecord.dashboard.insightLeading':
    '{type} 占比最高，约为全部记录的 {percent}%。',
  'easyRecord.dashboard.lastUpdated': '最近更新',
  'easyRecord.dashboard.coverageDescription':
    '已归入主题的记录占全部记录的比例。',
  'easyRecord.dashboard.organizedRecords': '已归入主题 {count} 条',
  'easyRecord.dashboard.metric.totalThreadsHint': '当前累计主题',
  'easyRecord.dashboard.metric.totalRecordsHint': '当前累计记录',
  'easyRecord.dashboard.metric.todayRecordsHint': '按本地日期统计',
  'easyRecord.dashboard.metric.weekRecordsHint': '近 7 日新增',
  'easyRecord.dashboard.metric.toOrganize': '待整理',
  'easyRecord.dashboard.metric.toOrganizeHint': '需归类、打标或回看的内容',
  'easyRecord.dashboard.metric.dailyAverageTitle': '日均记录',
  'easyRecord.dashboard.metric.dailyAverageHint': '近 7 日平均新增',
  'easyRecord.dashboard.metric.activeTopics': '未归档主题',
  'easyRecord.dashboard.metric.typeKinds': '{count} 类记录',
  'easyRecord.dashboard.metric.todayVsWeek': '本周共 {count} 条',
  'easyRecord.dashboard.metric.dailyAverage': '日均 {count} 条',
  'easyRecord.dashboard.memberCount': '{count} 位成员',
  'easyRecord.dashboard.rhythmTitle': '内容节奏',
  'easyRecord.dashboard.rhythmDailyAverage': '近 7 日日均记录',
  'easyRecord.dashboard.rhythmToday': '今日新增',
  'easyRecord.dashboard.rhythmRecent': '近期活跃',
  'easyRecord.dashboard.rhythmLastUpdated': '最近更新',
  'easyRecord.threads.description': '管理记录易中的主题信息与归档状态',
  'easyRecord.records.description': '浏览、筛选并管理记录易中的记录内容',
  'easyRecord.search.description': '按关键词搜索记录内容并快速回溯',
  'easyRecord.settings.description': '配置记录易的基础偏好设置',

  'easyRecord.action.addThread': '新建主题',
  'easyRecord.action.editThread': '编辑主题',
  'easyRecord.action.addRecord': '新增记录',
  'easyRecord.action.backToList': '返回列表',
  'easyRecord.action.archive': '归档',
  'easyRecord.action.unarchive': '取消归档',
  'easyRecord.action.pin': '置顶',
  'easyRecord.action.unpin': '取消置顶',
  'easyRecord.action.view': '查看',
  'easyRecord.action.edit': '编辑',
  'easyRecord.action.delete': '删除',
  'easyRecord.action.save': '保存',
  'easyRecord.action.reset': '重置',
  'easyRecord.action.search': '搜索',
  'easyRecord.action.refresh': '刷新',
  'easyRecord.action.confirm': '确认',
  'easyRecord.action.cancel': '取消',
  'easyRecord.action.complete': '完成',

  'easyRecord.common.actions': '操作',
  'easyRecord.common.loading': '加载中...',
  'easyRecord.common.noData': '暂无数据',
  'easyRecord.common.noRecords': '暂无记录',
  'easyRecord.common.total': '共 {count} 条',

  'easyRecord.confirm.deleteThread': '确认删除该主题吗？',
  'easyRecord.confirm.deleteContent': '同时删除主题下的记录',
  'easyRecord.confirm.deleteContentDesc':
    '勾选后将删除该主题及其关联的所有记录，此操作不可恢复。',

  'easyRecord.message.loadFailed': '加载失败，请稍后重试',
  'easyRecord.message.saveFailed': '保存失败，请稍后重试',
  'easyRecord.message.saveSuccess': '保存成功',
  'easyRecord.message.createSuccess': '创建成功',
  'easyRecord.message.updateSuccess': '更新成功',
  'easyRecord.message.deleteSuccess': '删除成功',
  'easyRecord.message.deleteFailed': '删除失败，请稍后重试',
  'easyRecord.message.pinSuccess': '置顶成功',
  'easyRecord.message.unpinSuccess': '已取消置顶',
  'easyRecord.message.archiveSuccess': '归档成功',
  'easyRecord.message.unarchiveSuccess': '已取消归档',

  'easyRecord.stats.totalThreads': '主题总数',
  'easyRecord.stats.totalRecords': '记录总数',
  'easyRecord.stats.todayRecords': '今日记录',
  'easyRecord.stats.weekRecords': '近 7 日记录',

  'easyRecord.recent.threads': '最近主题',
  'easyRecord.recent.activity': '近期活跃',

  'easyRecord.thread.title': '主题标题',
  'easyRecord.thread.description': '主题描述',
  'easyRecord.thread.recordDate': '记录日期',
  'easyRecord.thread.lunarDate': '农历日期',
  'easyRecord.thread.province': '省份',
  'easyRecord.thread.city': '城市',
  'easyRecord.thread.district': '区县',
  'easyRecord.thread.detailedLocation': '详细位置',
  'easyRecord.thread.location': '位置',
  'easyRecord.thread.weather': '天气',
  'easyRecord.thread.coverImageUrl': '封面图片地址',
  'easyRecord.thread.tags': '标签',
  'easyRecord.thread.notes': '备注',
  'easyRecord.thread.recordCount': '记录数量',
  'easyRecord.thread.isPinned': '已置顶',

  'easyRecord.form.required': '该项为必填项',
  'easyRecord.form.placeholder.title': '请输入主题标题',
  'easyRecord.form.placeholder.description': '请输入主题描述',
  'easyRecord.form.placeholder.recordDate': '请选择记录日期',
  'easyRecord.form.placeholder.lunarDate': '请输入农历日期',
  'easyRecord.form.placeholder.province': '请输入省份',
  'easyRecord.form.placeholder.city': '请输入城市',
  'easyRecord.form.placeholder.district': '请输入区县',
  'easyRecord.form.placeholder.detailedLocation': '请输入详细位置',
  'easyRecord.form.placeholder.weather': '请输入天气信息',
  'easyRecord.form.placeholder.coverImageUrl': '请输入封面图片地址',
  'easyRecord.form.placeholder.tags': '请输入标签（回车确认）',
  'easyRecord.form.placeholder.notes': '请输入备注',

  'easyRecord.record.untitled': '未命名记录',
  'easyRecord.record.recordType': '记录类型',
  'easyRecord.record.content': '记录内容',
  'easyRecord.record.summary': '摘要',
  'easyRecord.record.createdAt': '创建时间',
  'easyRecord.record.updateTime': '更新时间',
  'easyRecord.record.aiModel': 'AI 模型',
  'easyRecord.record.creator': '创建人',
  'easyRecord.record.isImportant': '重要',
  'easyRecord.record.notImportant': '普通',

  'easyRecord.task.title': '任务标题',
  'easyRecord.task.status': '状态',
  'easyRecord.task.priority': '优先级',
  'easyRecord.task.progress': '进度',
  'easyRecord.task.dueDate': '截止日期',

  'easyRecord.search.placeholder': '请输入关键词',
  'easyRecord.search.noResults': '暂无搜索结果',
  'easyRecord.search.recordType': '记录类型',
  'easyRecord.search.importance': '重要性',
  'easyRecord.search.status': '任务状态',
  'easyRecord.search.priority': '优先级',
  'easyRecord.search.dateRange': '日期范围',

  'easyRecord.settings.general': '通用设置',
  'easyRecord.settings.enableNotifications': '启用通知',
  'easyRecord.settings.autoSave': '自动保存',

  'easyRecord.device.search.keyword': '关键词',
  'easyRecord.device.search.keywordPlaceholder':
    '设备名称 / 型号 / 别名 / 序列号',
  'easyRecord.device.search.vendor': '品牌',
  'easyRecord.device.search.vendorPlaceholder': '请选择品牌',
  'easyRecord.device.search.status': '绑定状态',
  'easyRecord.device.search.statusPlaceholder': '请选择绑定状态',

  'easyRecord.device.table.deviceName': '设备名称',
  'easyRecord.device.table.vendor': '品牌',
  'easyRecord.device.table.category': '设备类型',
  'easyRecord.device.table.status': '状态',
  'easyRecord.device.table.alias': '绑定别名',
  'easyRecord.device.table.serialNumber': '设备序列号',
  'easyRecord.device.table.boundAt': '绑定时间',
  'easyRecord.device.table.updatedAt': '更新时间',

  'easyRecord.device.status.bound': '已绑定',
  'easyRecord.device.status.unbound': '未绑定',

  'easyRecord.device.view.all': '全部',
  'easyRecord.device.view.bound': '已绑定',
  'easyRecord.device.view.unbound': '未绑定',

  'easyRecord.device.action.bind': '绑定设备',
  'easyRecord.device.action.rebind': '重新绑定',
  'easyRecord.device.action.unbind': '解绑',

  'easyRecord.device.message.bindSuccess': '设备绑定成功',
  'easyRecord.device.message.unbindSuccess': '设备解绑成功',

  'easyRecord.device.futureHint': '设备接入能力预留',
  'easyRecord.device.futureHintDesc':
    '当前为前端占位管理页，后续可接入 Plaud、DingTalk One、出门问问等录音卡的鉴权、绑定、状态同步与音频导入。',

  'easyRecord.device.density.large': '宽松',
  'easyRecord.device.density.middle': '默认',
  'easyRecord.device.density.small': '紧凑',

  'easyRecord.device.modal.bindTitle': '绑定设备',
  'easyRecord.device.modal.devicePlaceholder': '请选择设备',
  'easyRecord.device.modal.aliasPlaceholder':
    '请输入设备别名（如：会议室录音卡）',
  'easyRecord.device.modal.serialPlaceholder': '请输入设备序列号',

  'easyRecord.priority': '优先级',
  'easyRecord.priority.urgent': '紧急',
  'easyRecord.priority.high': '高',
  'easyRecord.priority.medium': '中',
  'easyRecord.priority.low': '低',

  'easyRecord.status': '状态',
  'easyRecord.status.todo': '待办',
  'easyRecord.status.pending': '待处理',
  'easyRecord.status.in_progress': '进行中',
  'easyRecord.status.completed': '已完成',
  'easyRecord.status.cancelled': '已取消',
};
